
  <script>
   export default {
    props: {
        ClientID : String,
        viewportID : String
    },
    name: "RibbonData",
    data: () => ({
      //data: new TreeCollection(),
      ribbon: null,
      disabled: false,
      ClientId: this.ClientID
    }),
    methods: {
      handleAddClick() {
        /*this.data.update("print", {
          disabled: !this.data.getItem("print").disabled,
        });*/
      },
        disable(id) {
            this.ribbon.disable(id);
        },
        enable(id) {
            this.ribbon.enable(id);
        },
        hide(id) {
            this.ribbon.hide(id);
        },
        show(id) {
            this.ribbon.show(id);
        },
        makeCall() {
            console.log("==makecall params client===",this.ClientID);
            let callerAudioFlag = true, callerVideoFlag = false, callerScreenFlag = false;
            let params = {"ClientID":this.ClientID,"ToPE":null,"mediaType":"Audio"};
            
            if(params.mediaType == "Screen") {
              callerScreenFlag = true;
            } else if(params.mediaType == "Video") {
              callerVideoFlag = true;
            }
            let CallPE = params.ToPE;
            let InitialContext = {Caller:{Audio:callerAudioFlag,NoShow:true,Screen:callerScreenFlag,Video:callerVideoFlag},Callee:{Audio:true,NoShow:true,Screen:false,Video:false},Calltype:"JOINCALL",Label:"Invite"};
            let callObj = {Mode:"STARTMEDIA" ,ClientID:params.ClientID,DialTimeout:60,CallPE:CallPE,InitialContext:InitialContext,isSignedIn: false};
            window.BotServices.startCall(callObj);
        }
    },
    mounted() {
        this.ribbon = new dhx.Ribbon(this.$refs.ribbon, {
            css: "dhx_widget--bordered"
        });

        const config = [
        {
        "type": "block",
        "id": "dialeractions",
        "items": [
            {
                  type: "block",
                  items:[
                        {
                            value: "Nailup",
                            tooltip: "Start Nailup",
                            icon: "far fa-circle action-green",
                            id:"start_nailup",
                            hidden:false
                        },
                        {
                            value: "Nailup",
                            tooltip: "Stop Nailup",
                            icon: "far fa-circle action-red",
                            id:"stop_nailup",
                            hidden:true
                        },
                        {
                            value: "Dialer",
                            tooltip: "Start Dialer",
                            icon: "fal fa-phone-plus action-green",
                            id:"start_dialer",
                            hidden:false
                        },
                        {
                            type: "input",
                            value: "",
                            name: "batch_size",
                            id: "batch_size",
                            width: 100,
                            placeholder: "Batch Size",
                            hidden: true,
                        },
                        {
                            id:"2",
                            type: "selectButton",
                            value: "Batch",
                            size: "small",
                            hidden:true,
                            items: [
                                {
                                    value: "jpeg",
                                    hotkey: "alt+1"
                                },
                                {
                                    value: "pdf",
                                    hotkey: "alt+2"
                                },
                                {
                                    value: "png",
                                    hotkey: "alt+3"
                                }
                            ]

                            },
                            {
                                value: "Dialer",
                                tooltip: "Stop Dialer",
                                icon: "fas fa-phone-slash action-red",
                                id:"stop_dialer",
                                hidden:true
                            }
                       ]
                   }
               ]
        },
        {
                "id": "statusactions",
                "type": "block",
                "items": [
                     {
                        "type": "block",
                        "items": [
                            {
                                "id": "Available",
                                "value": "Available",
                                "group": "align",
                                "icon": "fal fa-globe action-green",
                                "hidden": false
                            },
                            {
                                "id": "Busy",
                                "value": "Busy",
                                "group": "align",
                                "icon": "fal fa-globe red-color action-red",
                                "hidden": true
                            }
                        ]
                    },
                ]
            },
        {
                "id": "callactions",
                "type": "block",
                "hidden":true,
                "items": [
                     {
                        "type": "block",
                        "items": [
                            {
                                "id": "DND",
                                "value": "DND",
                                "group": "align",
                                "icon": "fas fa-ban action-red"
                            },
                            {
                                "id": "Machine",
                                "value": "Machine",
                                "group": "align",
                                "icon": "fas fa-phone-slash action-red"
                            },
                            {
                                "id": "Hangup",
                                "value": "Hangup",
                                "group": "align",
                                "active": true,
                                "icon": "fas fa-phone-slash action-red"
                            }
                        ]
                    },
                ]
            }

    ];


    this.ribbon.data.add(config);

    const parent = this.ribbon.data.getParent("dialeractions");
    this.ribbon.data.add({ type: "spacer" }, this.ribbon.data.getIndex("dialeractions") + 1, parent);
   
        console.log("get state viewportId",this.viewportID);
        let client = window.botStore.getClientByViewPort(this.viewportID);
        let GrantPath = JSON.parse(client.ClientContext);
        let GrantPE = GrantPath.GrantPE;
        let currentContext = JSON.parse(client.CurrentContext);
        let requestContext = currentContext;
        requestContext.setClientId = this.ClientID;
        
        window.BotServices.commState({Action : 'getRibbonState', Data : requestContext}, (err,res) => {
            console.log("get state result",res);
            let event = res.Availability;
            if(event == "Busy") {
                this.show("Busy");
                this.hide("Available");
            } else if(event == "Available") {
                this.hide("Busy");
                this.show("Available");
            }
        });

    this.ribbon.events.on("click",function (event) {
        console.log("ribbon click event got:",event);
        if(event == "Available") {
            this.show("Busy");
            this.hide("Available");
            requestContext.Availability = 'Busy';
        } else if(event == "Busy") {
            this.hide("Busy");
            this.show("Available");
            requestContext.Availability = 'Available';
        } else if(event == "start_dialer") {
            this.hide("start_dialer");
            this.show("stop_dialer");
        } else if(event == "stop_dialer") {
            this.hide("stop_dialer");
            this.show("start_dialer");
        } else if(event == "start_nailup") {
            this.show("stop_nailup");
            this.hide("start_nailup");
            //this.makeCall();
            console.log("==makecall params client===",requestContext.setClientId);
            let callerAudioFlag = false, callerVideoFlag = false, callerScreenFlag = false;
            let params = {"ClientID":requestContext.setClientId,"ToPE":null,"mediaType":"AudiPso"};
            
            if(params.mediaType == "Screen") {
              callerScreenFlag = true;
            } else if(params.mediaType == "Video") {
              callerVideoFlag = true;
            }
            let CallPE = params.ToPE;
            let InitialContext = {Caller:{Audio:callerAudioFlag,NoShow:true,Screen:callerScreenFlag,Video:callerVideoFlag,Pstn:true},Callee:{Audio:true,NoShow:true,Screen:false,Video:false},Calltype:"JOINCALL",Label:"Invite"};
            let callObj = {Mode:"STARTMEDIA" ,ClientID:params.ClientID,DialTimeout:60,CallPE:CallPE,InitialContext:InitialContext,isSignedIn: false};
            window.BotServices.startCall(callObj);
        } else if(event == "stop_nailup") {
            this.show("start_nailup");
            this.hide("stop_nailup");
           // window.DevMgr.endcall(requestContext.setClientId);
        }
        
        window.BotServices.commState({Action : 'setRibbonState', Data : requestContext}, (err,res) => {
            console.log("set state result",res);
        });
    });
      
    },
    beforeDestroy() {
      if (this.ribbon) {
        this.ribbon.destructor();
      }
    },
    /*setup(props) {
      console.log("Property VP : ", props);

        console.log("get state viewportId",props.viewportID);
        let client = window.botStore.getClientByViewPort(props.viewportID);
        let GrantPath = JSON.parse(client.ClientContext);
        let GrantPE = GrantPath.GrantPE;
        let currentContext = JSON.parse(client.CurrentContext);
        let requestContext = currentContext;

      function getRibbonState() {
        window.BotServices.commState({Action : 'getRibbonState', Data : requestContext}, (err,res) => {
            console.log("get state result",res);
        });
      }

      function setRibbonState(event) {
        console.log("get state viewportId",props.viewportID);
        let client = window.botStore.getClientByViewPort(props.viewportID);
        let GrantPath = JSON.parse(client.ClientContext);
        let GrantPE = GrantPath.GrantPE;
        let currentContext = JSON.parse(client.CurrentContext);
        let requestContext = currentContext;

        requestContext.IconName = event;
        window.BotServices.commState({Action : 'setRibbonState', Data : requestContext}, (err,res) => {
            console.log("set state result",res);
        });
      }

      return {
        getRibbonState,
        setRibbonState
      }
    }*/
  };
  </script>

<template>
<div>
<div class="dhx-container--button" style="display: none;">
  <button @click="handleAddClick()" class="custom-button">
    disable/enable print button
  </button>
</div>
<div ref="ribbon"></div>
</div>
</template>
<style setup>
.action-blue {
  color:#0072c5 !important;
  font-size: 12px;
}

.action-red {
   color: red !important;
   font-size: 12px;
}

.action-green {
    color: green !important;
    font-size: 12px;
}

</style>